import {useMutation, useQueryClient} from '@tanstack/react-query'

import {createUser, updateUser} from './api'
import {userKeys} from './keys'
import {UserRequest, UserResponse} from './types'

export const useCreateUser = () => {
  const queryClient = useQueryClient()
  return useMutation<UserResponse, unknown, UserRequest>({
    mutationFn: createUser,
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: userKeys.lists()})
    },
  })
}

export const useUpdateUser = () => {
  const queryClient = useQueryClient()
  return useMutation<UserResponse, unknown, {id: string; body: UserRequest}>({
    mutationFn: ({id, body}) => updateUser(id, body),
    onSuccess: (_, {id}) => {
      queryClient.invalidateQueries({queryKey: userKeys.detail(id)})
      queryClient.invalidateQueries({queryKey: userKeys.lists()})
    },
  })
}
